import { render, staticRenderFns } from "./BlueButton.vue?vue&type=template&id=6a76c555&scoped=true&lang=pug&"
import script from "./BlueButton.vue?vue&type=script&lang=coffee&"
export * from "./BlueButton.vue?vue&type=script&lang=coffee&"
import style0 from "./BlueButton.vue?vue&type=style&index=0&id=6a76c555&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a76c555",
  null
  
)

export default component.exports